'use strict';

const Plaintext = window.Plaintext = (window.Plaintext || {});

Plaintext.DescriptionExpander = (function() {
  let mobileExpandedWraps = null;
  let expanderButtons = null;
  const contentVerticalPadding = 40;
  const toggleTransitionMs = 400;
  
  // Keep in sync with breakpoint in scss.
  const mobileMaxWidthPx = '1023';
  
  function init() {
    expanderButtons = document.querySelectorAll('.descExpander__button');
    expanderButtons.forEach(b => b.addEventListener('click', toggleExpansion));

    mobileExpandedWraps = document.querySelectorAll('.descExpander__wrap.descExpander--expandedOnMobile');

    window.addEventListener('resize', adjustForWindowSize);
    
    adjustForWindowSize();
    setDescribedByAttrs();
  }
  
  
  function toggleExpansion() {
    const isExpanding = !isButtonExpanded(this);
    const expander = this.closest('.descExpander');
    const content = expander.querySelector('.descExpander__content');

    if (isExpanding) {
      // This also forces reflow
      content.style.maxHeight = null;
      content.style.display = 'block';

      content.renderedHeight = (content.offsetHeight + 80 + contentVerticalPadding) + 'px'; 
      content.style.maxHeight = 0;
      
      window.requestAnimationFrame(function() {
        content.style.maxHeight = content.renderedHeight;
      });
      
      expander.classList.add('descExpander--expanded');
    }
    else {
      expander.classList.remove('descExpander--expanded');

      window.requestAnimationFrame(function() { content.style.maxHeight = 0; });
      window.setTimeout(function() { content.style.display = "none" }, toggleTransitionMs);
    }
    
    this.setAttribute('aria-expanded', (isExpanding) ? 'true' : 'false');
  }
  
  function setDescribedByAttrs() {
    expanderButtons.forEach(button => {
      const wrap = button.closest('.descExpander__wrap')
      const descId = wrap.querySelector('.descExpander__content').id;
      wrap.setAttribute('aria-describedby', descId);
    });
  }
  
  function isButtonExpanded(button) {
    if (!button.hasAttribute('aria-expanded')) { return false; }
    
    return (button.getAttribute('aria-expanded') !== 'false'); 
  }
  
  function adjustForWindowSize() {
    const expanderContent = document.querySelectorAll('.descExpander__content');
    
    // Clear maxHeight from all expanded content.  It's only used for animating the transition, and this avoids
    // recalculating height on every resize.
    expanderContent.forEach(e => e.style.maxHeight = null); 

    // Remaining adjustments are only related to the --expandedOnMobile variant
    if (!mobileExpandedWraps.length) { return; }

    const viewWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isMobileView = (viewWidth <= mobileMaxWidthPx);
    const mobileViewChanged = (Plaintext.DescriptionExpander.wasMobileView !== isMobileView);
    
    if (!mobileViewChanged) { return; }
    
    Plaintext.DescriptionExpander.wasMobileView = isMobileView;
    const newButtonDisplay = (isMobileView) ? 'none' : 'block';

    // Toggling from mobile/desktop behaviour
    mobileExpandedWraps.forEach(wrap => {
      const button = wrap.querySelector('.descExpander__button');
      const content = wrap.querySelector('.descExpander__content');
      const isExpanded = isButtonExpanded(button);
    
      button.style.display = newButtonDisplay;
      content.style.display = (isMobileView || isExpanded) ? 'block' : null;
    });
  }
  
  return {
    init
  }
})();